import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './Home';
import PrivacyPolicy from './PrivacyPolicy';
import ProfileSettings from './components/ProfileSettings';
import AccountDeletion from './components/AccountDeletion';
import TenantGuide from './TenantGuide';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/profile-settings" element={<ProfileSettings />} />
        <Route path="/account-deletion" element={<AccountDeletion />} />
        <Route path="/tenant-guide" element={<TenantGuide />} />
      </Routes>
    </Router>
  );
}

export default App;